import React from "react";
import "../style/services.css";
import Servicescard from "./Servicescard";


export default function ServicesContent() {
  

  return (
    <div className="services-content" id="services">
      <h1
  style={{
    width: "80%",
    textAlign: "center",
    marginTop: "20px",
    marginBottom: "10px",
    fontFamily: "var(--fontFamily)",
    fontWeight: "800",
    color: "var(--mainColorLight)",
    textShadow: "1px 1px 3px rgba(0, 0, 0, 0.1)",
  }}
>
  Willkommen bei Ihrem Partner für Reinheit.
</h1>
<h3
  style={{
    width: "80%",
    textAlign: "center",
    marginBottom: "50px",
    fontFamily: "var(--fontFamily)",
    fontWeight: "400",
    color: "var(--textColor)",
    opacity: "0.9",
  }}
>
  Perfektion, auf die Sie sich verlassen können.
</h3>

      <Servicescard />
    </div>
  );
}
